import React, { Component } from 'react';
import { SimpleForm, TextInput, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

class PriorizacionForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props}>
        {this.props.children}
        <FieldGroup label="fieldGroups.priorizacionEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.priorizacionEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.priorizacionPt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(PriorizacionForm);
